import type { IconData } from '@stacksjs/iconify-core'

export const logoPinterest: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 3.05H32v25.9h-1.53Zm-1.52 25.9h1.52v1.53h-1.52Zm0-27.43h1.52v1.53h-1.52ZM3.04 30.48h25.91V32H3.04ZM24.38 6.09h-1.53V4.57h-3.04V3.05h-6.1v1.52h-3.05v1.52H9.14v1.53H7.61v1.52H6.09v4.57h1.52v1.53h1.53v-1.53h1.52v-3.04h1.53V9.14h7.62v1.53h1.52v3.04h-1.52v3.05h-1.53v1.53h-3.05v-1.53h1.53v-3.05h-1.53v-1.52h-3.04v1.52h-1.53v3.05H9.14v3.05H7.61v3.05H6.09v4.57h1.52v1.52h1.53v-1.52h1.52v-3.05h1.53v-3.05h3.04v1.53h4.58v-1.53h1.52v-1.52h1.52v-1.52h1.53v-3.05h1.52v-6.1h-1.52zM3.04 0h25.91v1.52H3.04ZM1.52 28.95h1.52v1.53H1.52Zm0-27.43h1.52v1.53H1.52ZM0 3.05h1.52v25.9H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default logoPinterest
